import { createSlice } from '@reduxjs/toolkit';

const navigationSlice = createSlice({
  name: 'navigation',
  initialState: {
    isSideNavOpen: true,
  },
  reducers: {
    toggleSideNav: (state) => {
      state.isSideNavOpen = !state.isSideNavOpen;
    },
  },
});

export const { toggleSideNav } = navigationSlice.actions;
export default navigationSlice.reducer;
